<template>
  <!-- 选择内容的弹出框   -->
  <div>
    <el-dialog title="绑定内容"
               class="content-dialog"
               :visible.sync="visible"
               :show="show"
               top="10vh"
               width="80%"
               @open="openDialog"
               @close="handleClose">
      <!-- 筛选区 -->
      <div class="filter-area">
        <!-- 目的地 -->
        <div>
          <select-dest placeholder="所属目的地"
                       @selectDest="selectDest"></select-dest>
        </div>
        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入搜索内容"
                  v-model="searchContentKeyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
        <!-- 新建 -->
        <div style="margin-left:auto">
          <el-button @click="creatNewTraverContent"
                     size="mini"
                     type="">新建内容</el-button>
          <!-- 提交绑定 -->
          <el-button @click="bandTraverContent"
                     size="mini"
                     type="primary">绑定</el-button>
        </div>
      </div>
      <div class="filter-area-tag">
        <select-tag :showTitle="true"
                    :creatNewTag="false"
                    :tagList="contentTags"
                    @getSelectList="getSelectList"></select-tag>
      </div>
      <!-- -------------内容列表------------- -->
      <div class="content-card-check-list">
        <card-check-list :cardList="content_list"
                         :showUpdate="false"
                         :showDest="false"
                         :showMiniTitle="false"
                         @checkedItem="checkedItem"
                         buttonName=""></card-check-list>
      </div>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CardCheckList from '../cards/CardCheckList'
import SelectDest from '../select/SelectDest'
import SelectTag from '../select/SelectTag'
export default {
  name: 'select-and-search-content',
  components: {
    'select-dest': SelectDest,
    'select-tag': SelectTag,
    'card-check-list': CardCheckList,
  },
  data() {
    return {
      loading: true,
      visible: this.show,
      searchContentKeyword: '',
      dest: '',
      content_list: [], //显示的内容列表
      band_content_list: [], // 需要绑定的内容
      contentTags: [],
      tag_list: [],
      pagenum_system: 1,
      pagesize: 30,
      page_account: null,
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.visible = val
      },
    },
  },
  mounted() {},
  methods: {
    // 打开对话框时
    openDialog() {
      this.getAllContentTag()
      this.getContentList()
    },
    // 选择内容
    checkedItem(val) {
      this.band_content_list = val
    },
    //  绑定内容给迹点
    bandTraverContent() {
      this.$emit('bandTraverContent', this.band_content_list)
    },
    // 关闭回调
    handleClose() {
      this.content_list = []
      this.band_content_list = []
      this.$emit('update:show', false)
    },
    // 选择目的地
    selectDest(value) {
      this.dest = value
    },
    // 搜索
    searchButton() {
      this.getContentList()
    },
    // 新建内容
    creatNewTraverContent() {
      let routeData = this.$router.resolve({ name: 'creat_content' })
      window.open(routeData.href, '_blank')
    },
    // 选择标签的回调
    getSelectList() {},
    // 获取所有内容标签
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
          // console.log(this.contentTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    handleCurrentChange_system(page) {
      this.content_list = []
      this.pagenum_system = page
      this.getContentList()
    },
    // 获取内容列表
    getContentList() {
      this.$http
        .get(
          `/traver/get_content_list?title=${this.searchContentKeyword}&dest=${this.dest}&tag=${this.tag_list}&p_size=${this.pagesize}&p_num=${this.pagenum_system}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            let list = res.data.content
            this.page_account = res.data.item_account
            list.forEach((i) => {
              let item = {
                id: i.id,
                title: i.title,
                title_mini: i.introduce,
                image: i.cover_image,
                corner_name: i.dest,
                tag: i.tag,
                update_time: i.update_time,
                type: i.type,
              }
              this.content_list.push(item)
              this.loading = false
            })
          }
        })
    },
  },
}
</script>

<style>
/* .content-dialog .el-dialog__body {
  background-color: red;

} */
.filter-area {
  display: flex;
}
.filter-area-tag {
  margin-top: 20px;
}
.content-card-check-list {
  overflow: scroll;
  max-height: 350px;
  margin-top: 20px;
  border: 1px solid rgb(182, 181, 181);
  background-color: rgb(231, 230, 230);
  padding: 5px;
}
</style>